interface CornerDownRightIconProps {
  className?: string;
}

const CornerDownRightIcon: React.FC<CornerDownRightIconProps> = ({
  className,
}) => (
  <svg
    aria-hidden="true"
    className={className}
    data-icon="corner-down-right"
    fill="none"
    focusable="false"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m15 10 5 5-5 5" />
    <path d="M4 4v7a4 4 0 0 0 4 4h12" />
  </svg>
);

export default CornerDownRightIcon;
